import { render, staticRenderFns } from "./RegexTest.vue?vue&type=template&id=47ecd9c7"
import script from "./RegexTest.vue?vue&type=script&lang=js"
export * from "./RegexTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports